export default "__VITE_ASSET__56493e57__"